import { Container, Image, Row, Col, Stack } from 'react-bootstrap';
import styled from 'styled-components';
import React from 'react';

const StyledContainer = styled(Container)`
    &&& {
        background: white;
        z-index: 1;
    }
`;

const StyledStack = styled(Stack)`
    &&& {
        color: rgba(0, 0, 0, 0.5);
        font-weight: 500;
        font-family: 'Poppins';
        text-align: center;
    }

    @media (max-width: 460px) {
        padding: 0 15px;
    }
`;

const StyledImage = styled(Image)`
    &&& {
        width: 175px;
    }

    @media (min-width: 300px) and (max-width: 500px) {
        width: 50px;
    }
`;

const StyledImage2 = styled(Image)`
    &&& {
        margin-top: 8px;
    }

    @media (min-width: 300px) and (max-width: 500px) {
        width: 100%;
        margin-top: 0;
    }
`;

const ImageContainer = styled.div`
    display: flex;
    // justify-content: center;
    // align-items: center;
    padding: 40px;

    @media (min-width: 300px) and (max-width: 500px) {
        position: static;
        top: 0;
        padding: 20px;
    }
`;

const ICParagraphText = styled.p`
    color: #a7a9ac;
    font-weight: 500;
    font-size: 12px;
    font-family: 'Montserrat';
    text-align: center;
`;

const StyledDivision = styled.div`
    padding: 20px 50px 20px 20px;
    margin: 0% 15%;
    border-bottom: 2px solid gray;
`;

export default function Footer({ paramsData }) {
    const sustainabilityLogo = paramsData.find((item) => item.paramName === 'BPI_SUSTAINABILITY_LOGO');
    
    return (
        <StyledContainer id="contact-us" fluid>
            <Row className="d-flex justify-content-center align-items-center">
                <Col xs="auto" className="p-0">
                    <ImageContainer>
                        <StyledImage src={require('../../assets/bpims-logo.png')} fluid />
                    </ImageContainer>
                </Col>
                <Col xs="auto" className="p-0">
                    <ImageContainer>
                        <StyledImage2 src={require('../../assets/home-credit-logo-1.png')} fluid />
                    </ImageContainer>
                </Col>
            </Row>
            <Row>
                <Col lg={12} className="justify-content-center pt-3">
                    <StyledStack className="text-center mb-5">
                        <p className="m-0 p-0">Powered by BPI/MS Insurance Corporation, a joint venture between the</p>
                        <p className="m-0 p-0 mb-3">
                            Bank of the Philippine Islands and Mitsui Sumitomo Insurance Company, Limited.
                        </p>
                        <p className="m-0 p-0" style={{ fontWeight: 'bold' }}>
                            Policy terms and conditions apply.
                        </p>
                        <p className="m-0 p-0">
                            BPI/MS Insurance Corporation's products are non-life insurance products and are not deposit
                        </p>
                        <p className="m-0 p-0">
                            products of Bank of the Philippine Islands. These products are not covered by the Philippine
                            Deposit
                        </p>
                        <p className="m-0 p-0">Insurance Corporation.</p>
                        <br />
                        <p className="m-0 p-0">
                            For concerns, you may call BPI MS at{' '}
                            <a href="tel:(+632) 8840-9000" target="_blank">
                                (+632) 8840-9000
                            </a>{' '}
                            or send an e-mail to{' '}
                            <a href="mailto:BPIMS_Non-Motor_Claims@bpi.com.ph" target="_blank">
                                BPIMS_Non-Motor_Claims@bpi.com.ph
                            </a>
                            ,
                        </p>
                        <p className="m-0 p-0">&nbsp;Monday to Friday, 8AM to 5PM except holidays.</p>
                        <br />
                        <p className="m-0 p-0">
                            BPI/MS Insurance Corporation is regulated by the Insurance Commission (IC).
                        </p>
                        <p className="m-0 p-0">For more details, visit https://www.insurance.gov.ph.</p>
                        <br />
                        <ICParagraphText className="m-0 p-0">
                            IC Public Assistance Office contact details:
                        </ICParagraphText>
                        <ICParagraphText className="m-0 p-0">Landline: (02) 8523-8461 loc. 103/127</ICParagraphText>
                        <ICParagraphText className="m-0 p-0">SMS: 09171160007 or 09999930637</ICParagraphText>
                        <ICParagraphText className="m-0 p-0">E-mail: publicassistance@insurance.gov.ph</ICParagraphText>
                        <ICParagraphText className="m-0 p-0">
                            Offices: https://www.insurance.gov.ph/contact-us/
                        </ICParagraphText>
                        {/* <StyledHr /> */}

                        {sustainabilityLogo && (
                            <>
                                <StyledDivision />
                                <StyledImage
                                    src={sustainabilityLogo.paramValueV}
                                    alt="Sustainability logo"
                                    fluid
                                    className="mx-auto py-4"
                                    width="200px"
                                />
                                <p>BPI MS’ Digital Evolution Insures the Future </p>
                            </>
                        )}
                    </StyledStack>
                </Col>
            </Row>
        </StyledContainer>
    );
}
